import { parsePhoneNumberFromString } from 'libphonenumber-js';
import type { TelephoneNumber } from '#types/System.FieldTypes.types';

function formatNationalDigitsForDisplay(number: string): string {
  const digits = number.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length > 6) {
    return digits.replace(/(\d{3})(\d{3})(\d+)/, '$1 $2 $3');
  }
  return digits;
}

export function formatTelephoneFromComponents(
  components: NonNullable<TelephoneNumber['components']>,
): string {
  const parts: string[] = [];

  if (components.countryCode) {
    parts.push(components.countryCode);
  }

  if (components.number) {
    try {
      const fullNumber = `${components.countryCode || ''}${components.number}`;
      const phoneNumber = parsePhoneNumberFromString(fullNumber);
      if (phoneNumber) {
        parts.length = 0;
        parts.push(phoneNumber.formatInternational());
      } else {
        parts.push(formatNationalDigitsForDisplay(components.number));
      }
    } catch {
      if (!components.countryCode) {
        parts.push(formatNationalDigitsForDisplay(components.number));
      } else {
        parts.push(components.number);
      }
    }
  }

  if (components.extension) {
    parts.push(`ext ${components.extension}`);
  }

  return parts.join(' ');
}
